import roles from '@/constants/roles';

export type Dashboard = 'member' | 'organization' | 'peerSupport' | 'creator';

export const dashboardHomes: Record<Dashboard, string> = {
  member: '/user/dashboard',
  organization: '/organization/dashboard',
  peerSupport: '/organization/dashboard/peer-support',
  creator: '/creator/dashboard',
};

export const dashboardLabels: Record<Dashboard, string> = {
  member: 'Member',
  organization: 'Organization',
  peerSupport: 'Peer Support',
  creator: 'Creator',
};

export const getAvailableDashboards = (userRoles: string[] = []): Dashboard[] => {
  const dashboards: Dashboard[] = [];
  const creatorOnly = userRoles.length === 1 && userRoles.includes(roles.contentCreator);
  if (!creatorOnly) dashboards.push('member');
  if (userRoles.includes(roles.orgAdmin)) dashboards.push('organization');
  if (userRoles.includes(roles.peerSupport) || userRoles.includes(roles.peerSupportLead))
    dashboards.push('peerSupport');
  if (userRoles.includes(roles.contentCreator)) dashboards.push('creator');
  return dashboards;
};

// Shared routes deliberately keep the dashboard chosen by the user.
export const dashboardForPath = (pathname: string): Dashboard | null => {
  if (pathname.startsWith('/organization/dashboard/peer-support')) return 'peerSupport';
  if (pathname.startsWith('/organization/dashboard') || pathname.startsWith('/organization/roster'))
    return 'organization';
  if (
    pathname.startsWith('/creator/dashboard') ||
    pathname.startsWith('/creator/library') ||
    pathname.startsWith('/creator/profile') ||
    pathname.startsWith('/creator/content')
  ) return 'creator';
  if (pathname.startsWith('/user/dashboard') || pathname.startsWith('/user/growth-zone')) return 'member';
  return null;
};
